import useGlobalStartPage from '../globalContent/useGlobalStartPage'

export default function useRootLink() {
  const globalStartPage = useGlobalStartPage()
  if (globalStartPage?.locale === 'en') return '/en/'
  return '/'
}
